<template>
<div class="chapter">
<div class="inner_page">
<div class="cap">
<p class="image"><a id="page_6"><img alt="Image" src="images/pg6.jpg"/></a></p><a id="page_6">
<p class="figcaption">Chicago’s North Side, Early to Mid 20th Century</p>
</a></div><a id="page_6">
<p class="pgbreak">
</p></a><div class="cap"><a id="page_6">
</a><p class="image"><a id="page_6"></a><a id="page_7"><img alt="Image" src="images/pg7.jpg"/></a></p><a id="page_7">
<p class="figcaption">Neighborhood Associations Affiliated with the Lincoln Park Conservation Association</p>
</a></div><a id="page_7">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_Fm01.vue?4739a6de